<template>
  <div class="ba-node-report-etc"
       ref="nodeReportEtc">
    <div class="report-header">
      <h3>
        <em><span>{{ pageData._seqIndex + 1}}</span> Sequence</em>
        {{ $t('trend.etcReport.etcBelow', { value: 6 }) }}
      </h3>
    </div>

    <div class="report-body">
      <div class="pageview">
        <ba-node-report-thru-info v-if="pageData.thruData"
                                  :highlightedSequenceIndex="pageData.highlightedSequenceIndex"
                                  :highlightedNodeIndex="pageData.highlightedNodeIndex"
                                  :highlightedNodeInfo="pageData.highlightedNodeInfo" />

        <div class="info-wrap">
          <div class="info">
            <p class="url">
              {{ isCustomNode ? 'Tag' : 'URL' }}
              <span class="em">{{ (pageData.thruData ? pageData.thruData.urlCnt || 0 : pageData.urlCnt) | thousand }}</span>
              <span v-if="pageData.thruData"
                    class="total">/ {{ pageData.urlCnt | thousand }}</span>
            </p>
            <p class="session">
              <i class="icon icon--ba-session"></i>
              Session
              <template v-if="pageData.sessCntIsInaccurate">
                <span class="invalid-value" v-html="$t('common.invalidValueDesc')"></span>
              </template>
              <template v-else >
                <span class="em invalid-value" v-if="pageData.thruData && pageData.thruData.sessCntIsInaccurate" v-html="$t('common.invalidValueDesc')"></span>
                <span class="em" v-else>{{ getComputedThruSessCnt | thousand }}</span>
                <span v-if="pageData.thruData" class="total">/ {{ getComputedSessCnt | thousand }}</span>
              </template>
              <span v-html="$t('trend.etcReport.percentOfSequence', {
                      sequence: pageData._seqIndex + 1,
                      percent: (((pageData.thruData ? pageData.thruData.sessCnt || 0 : getComputedSessCnt) / pageData._seqSessCnt) * 100).toFixed(1) + '%' + (pageData.thruData ? ' <span class=\'total\'>/ ' + ((getComputedSessCnt / pageData._seqSessCnt) * 100).toFixed(1) + '%</span>' : '') })"></span>
            </p>
          </div>

          <div class="chart">
            <app-chart chartType="pie"
                       class="app-chart"
                       v-if="pvChartOptions"
                       :chartOptions="pvChartOptions"
                       :width="140"
                       :height="140" />
          </div>
        </div>

        <div class="url-list">
          <p class="notice">
            <i class="icon icon--bell-gray"></i>
            <span>{{ $t('trend.etcReport.upTo100') }}</span>
          </p>

          <table :class="{'custom': isCustomNode}">
            <thead>
              <tr>
                <th class="item--url">{{ isCustomNode ? 'Tag' : $t('common.url') }}</th>
                <th class="item--session">{{ $t('common.session') }}</th>
              </tr>
            </thead>
            <tbody ref="tBody">
              <tr v-for="(urlItem, index) in urlList" :key="index">
                <td class="item--url">
                  <a :href="getUrlItemHref(urlItem)" target="_blank" v-if="!isCustomNode">
                    <span class="url">{{ urlItem.linkUrl }}</span>
                  </a>
                  <span v-else>
                    {{ getCustomLabel(urlItem) }}
                  </span>
                </td>
                <td class="item--session">
                  <!-- <template v-if="urlItem.countIsInaccurate">
                    {{ getComputedSessCntByUrl(urlItem) | thousand }}
                  </template>
                  <template v-else>
                  </template> -->
                  {{ getComputedThruSessCntByUrl(urlItem) | thousand }}
                  <span v-if="pageData.thruData" class="total">/ {{ getComputedSessCntByUrl(urlItem) | thousand }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <back-to-top :refName="'nodeReportEtc'"
                   :hideLabel="true" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { simpleUrl } from '@/libs/utils'

import AppChart from '@/components/chart'
import BackToTop from '@/components/ui/BackToTop'
import BaNodeReportThruInfo from '@/components/trend/NodeReportThruInfo'

export default {
  name: 'BaNodeReportEtc',
  components: {
    AppChart,
    BackToTop,
    BaNodeReportThruInfo
  },
  props: {
    pageData: {
      type: Object,
      required: true
    },
    originData: {
      type: Object,
      required: false
    },
    isCustomNode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      urlList: []
    }
  },
  computed: {
    ...mapState([
      'journeyOptions',
      'domain',
      'isSampling'
    ]),
    getComputedThruSessCnt () {
      // return this.pageData.thruData ? this.pageData.thruData.sessCnt || 0 : this.pageData.sessCnt
      if (this.pageData.thruData) {
        return this.pageData.thruData.sessCntIsInaccurate ? this.$t('common.invalidValueDesc') : this.pageData.thruData.sessCnt || 0
      } else {
        return this.pageData.sessCnt
      }
    },
    getComputedSessCnt () {
      return this.pageData.sessCnt
    },
    isSamplingOptions () {
      return this.isSampling && (!this.journeyOptions.survey || this.journeyOptions.survey === {})
    },
    pvChartOptions () {
      return {
        series: [
          {
            type: 'pie',
            data: this.pageData.thruData ? [
              {
                name: 'etc-thru',
                value: this.pageData.thruData.sessCnt || 0
              },
              {
                name: 'etc',
                value: (this.pageData.sessCnt - (this.pageData.thruData.sessCnt || 0)) || 0
              },
              {
                name: 'default',
                value: (this.pageData._seqSessCnt - (this.pageData.sessCnt || 0)) || 0
              }
            ] : [
              {
                name: 'etc',
                value: this.pageData.sessCnt || 0
              },
              {
                name: 'default',
                value: (this.pageData._seqSessCnt - (this.pageData.sessCnt || 0)) || 0
              }
            ],
            hoverAnimation: false,
            cursor: 'default',
            label: {
              show: false
            },
            tooltip: {
              show: false
            },
            silent: true,
            radius: ['35%', '100%'],
            width: 140,
            height: 140
          }
        ],
        color: this.pageData.thruData ? ['#0e90a5', '#89c6d0', '#d8d8d8'] : ['#0e90a5', '#d8d8d8']
      }
    }
  },
  mounted () {
    const urlList = []
    for (let key in this.pageData._urlList) {
      const urlItem = this.pageData._urlList[key]
      if (urlItem) {
        const url = this.getUrlItemHref(urlItem, key)
        this.pageData._urlList[key].linkUrl = simpleUrl(url, this.journeyOptions.matchType)
        urlList.push(this.pageData._urlList[key])
      }
    }
    urlList.sort(this.pageData.thruData ? this.sortByThruCnt : this.sortByCount)
    this.urlList = urlList

    this.$nextTick(() => {
      const $trs = [].slice.call(this.$refs.tBody.querySelectorAll('tr'))
      $trs.forEach(($node) => {
        const $link = $node.querySelector('a')
        $node.classList[!$node.querySelector('.total') || ($link && $link.offsetHeight > 20) ? 'add' : 'remove']('long')
      })
    })
  },
  methods: {
    getUrlItemHref (urlItem, key) {
      if (this.journeyOptions.matchType === 'exact') {
        return String(urlItem.url || urlItem.id || key || '')
      }
      return urlItem.url ? String(urlItem.url) : ''
    },
    getCustomId (urlItem) {
      const customId = urlItem.customId !== undefined && urlItem.customId !== null ? urlItem.customId : urlItem.id
      return isNaN(customId) ? customId : Number(customId)
    },
    getCustomLabel (urlItem) {
      return this.getCustomId(urlItem) === 0 ? this.$t('customTag.untaggedLabel') : urlItem.customValue
    },
    getComputedThruSessCntByUrl (urlItem) {
      if (this.pageData.thruData) {
        return urlItem.thruCntIsInaccurate ? this.$t('common.invalidValue') : urlItem.thruCnt || 0
      } else {
        return urlItem.countIsInaccurate ? this.$t('common.invalidValue') : urlItem.count
      }
    },
    getComputedSessCntByUrl (urlItem) {
      return urlItem.countIsInaccurate ? this.$t('common.invalidValue') : urlItem.count
    },
    sortByThruCnt (a, b) {
      return b.thruCnt - a.thruCnt || b.count - a.count
    },
    sortByCount (a, b) {
      return b.count - a.count
    }
  }
}
</script>

<style lang="scss" scoped>
.ba-node-report-etc {
  box-sizing: border-box;
  width: 100%;

  a {
    color: inherit;
  }

  .report-header {
    position: relative;
    box-sizing: border-box;
    padding: 23px 20px 15px;
    background-color: #4b5263;

    h3 {
      font-size: 18px;
      font-weight: 500;
      color: #ccc;
      line-height: 1;

      em {
        font-size: 12px;
        color: #fff;
        line-height: 1;
        margin-bottom: 4px;
        display: block;

        span {
          font-size: 36px;
          color: #fff;
          line-height: 1;
          padding-right: 5px;
          transform: translateY(1px);
          display: inline-block;
        }
      }
    }
  }

  & /deep/ {
    .node-report-thru-info {
      margin: -30px -12px 38px;
    }
  }

  .report-body {
    padding: 0 20px 35px 20px;

    .pageview {
      position: relative;
      border-radius: 14px;
      box-shadow: 0 12px 13px -7px rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.15);
      background-color: #ffffff;
      margin: 20px 0;
      padding: 38px 20px 14px;

      .info-wrap {
        position: relative;
      }

      .info {
        p {
          font-size: 15px;
          font-weight: bold;
          color: #555;
          line-height: 1;

          .em {
            font-size: 32px;
            line-height: 1;
            margin-top: 5px;
            display: block;
          }

          span {
            font-size: 13px;
            font-weight: 500;
            line-height: 1;
            margin-top: 5px;
            display: block;
          }

          .total {
            font-size: 18px;
            font-weight: bold;
            color: #aaa;
            line-height: 1;
            margin-top: 4px;
          }

          &.session {
            position: relative;
            color: #0e90a5;
            margin-top: 25px;
            padding: 3px 0 0 28px;

            .icon {
              position: absolute;
              left: 0;
              top: 0;
            }

            .em,
            span {
              margin-left: -28px;
            }
            .em {
              margin-top: 8px;
            }
            span /deep/ .total {
              color: #89c6d0;
            }

            .total {
              color: #89c6d0;
              margin-bottom: 11px;
            }
            .invalid-value {
              max-width: 192px;
              font-size: 14px;
              line-height: 1.2;
              margin-bottom: 8px;
            }
          }
        }
      }

      .chart {
        position: absolute;
        top: 0;
        right: 0;
        width: 142px;
        height: 142px;
      }

      .node-report-thru-info ~ .info-wrap .chart {
        top: 13px;
      }

      .url-list {
        .notice {
          position: relative;
          font-size: 12px;
          color: #666;
          line-height: 1.5;
          margin-top: 50px;
          padding: 1px 0 0 25px;

          .icon {
            position: absolute;
            top: 0;
            left: 0;
          }
        }

        table {
          font-size: 13px;
          width: 100%;
          margin-top: 48px;

          th {
            font-weight: 500;
            font-size: 13px;
            color: #767676;
            text-align: center;
            line-height: 1.38;
            padding: 0 10px 5px;
            border-bottom: 1px solid #bbbbbb;

            &.item--session {
              text-align: right;
            }
          }

          td {
            font-size: 13px;
            color: #444;
            line-height: 1.38;
            vertical-align: top;
            word-break: break-all;
            padding: 16px 10px;

            &.item--session {
              text-align: right;
              white-space: nowrap;

              .total {
                font-size: 12px;
                color: #888888;
                display: block;
              }
            }
          }

          tr:not(.long) td.item--session {
            padding-top: 8px;
            padding-bottom: 8px;
          }

          tr:not(:last-child) td {
            border-bottom: 1px solid #ebebeb;
          }
        }
      }
    }
  }

  .btn__back-to-top {
    margin-top: 50px;
    margin-bottom: -20px !important;
  }
}
</style>
